import { lightTheme, ShrikeTheme, perchTheme } from '@perch-labs/shrike';
import { merge } from 'lodash';
import arcadiaFavicon from 'static/favicon.png';
import perchFavicon from 'static/perch-favicon.png';
// https://styled-system.com/theme-specification#space
// use the index of the value you'd like for styled-system spacing
// marginTop={2} converts to margin-top: 8px;
const space = [
  0, // 0
  4, // 1
  8, // 2
  12, // 3
  16, // 4
  24, // 5
  32, // 6
  48, // 7
  64, // 8
  128, // 9
] as const;

export interface FlexTheme extends ShrikeTheme {
  space: readonly number[];
}

export const theme: FlexTheme = merge(lightTheme, { space });

const updateFavicon = (entity: string): void => {
  const favicon = entity === 'Perch' ? perchFavicon : arcadiaFavicon;
  document
    .querySelectorAll("link[rel='icon'], link[rel='shortcut icon']")
    .forEach(link => link?.setAttribute('href', favicon));
};

export const getTheme = (entity): FlexTheme => {
  updateFavicon(entity);
  if (entity === 'Perch') {
    return merge(perchTheme, { space });
  }
  return merge(lightTheme, { space });
};
